import { useEffect, useState } from "react";
import Page from "../../../components/Page";
import Slider from "react-slick";
import "./CoacheDetail.scss";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getProcureInfo,
  scrollIntoViewWithOffset,
  SessionKeys,
} from "../../../utils/AppUtils";
import {
  coachingDetail,
  coachingDetailClear,
} from "../../../redux/provider/actions";
import {
  coachingRequestSubmit,
  GetCoachRating,
  GetCoachRatingClear,
} from "../../../redux/coaching/actions";
import Loader from "../../../components/Loader/Loader";
import { userDetailBroker } from "../../../redux/user/actions";

import { useTranslation } from "react-i18next";
import CoachRating from "../CoachRating";
import SlotBookingModal from "../../../components/NewDesign/Halifax/Coaching/SlotBookingModal";
import { Rating } from "@mui/material";
import { RightArrowIcon } from "../../../utils/SvgComps";
import { routeList } from "../../../utils/routeList";
import ShimmerScreen from "../../../components/Layouts/ShimmerScreen";
import ReactRoundedImage from "react-rounded-image";
function CoacheDetail({ service_code }) {
  const { t } = useTranslation();
  const location = useLocation();
  const userRole = useSelector((state) => state.user.role);
  const role = location.state?.role ? location.state?.role : userRole;
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const c = params.get("c");
  let coach_id = "";
  if (role !== "provider" && c) {
    let decodedString = atob(c);
    let paramsReq = JSON.parse(decodedString);
    coach_id = paramsReq.coach_id;
  }

  const dispatch = useDispatch();

  const serviceCode = location.state?.service_code;

  const [coachData, setCoachData] = useState();
  const [loader, setLoader] = useState(false);
  const [show, setShow] = useState(false);
  const [banner, setBanner] = useState(false);

  const [sessionModal, setSessionModal] = useState(false);
  const [selectedCoachId, setSelectedCoachId] = useState("");
  const [productTitle, setProductTitle] = useState("");
  const [productId, setProductId] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [ratingFeedbackList, setRatingFeedbackList] = useState([]);
  const [coachId, setCoachId] = useState("");
  const coachingDetailResponse = useSelector(
    (state) => state.provider.coachingDetail
  );
  const userDetailBrokerResponse = useSelector(
    (state) => state.user.userBroker
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    getCoachRatingCall();
  }, [coachId]);
  const RatingAndFeedbackResponse = useSelector(
    (state) => state.coaching.getcoachRating
  );

  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const encodedToken = params.get("c");
    console.log("inside useffect");
    if (encodedToken) {
      try {
        const decodedString = atob(encodedToken); // Decode Base64
        const decodedData = JSON.parse(decodedString);
        console.log("decodedData", decodedData);

        if (decodedData.rating === "true") {
          console.log("rating is true");
          setShow(true);
        }
      } catch (error) {
        console.error("Invalid token format", error);
      }
    }
  }, [location]);

  const [ratingLoader, setRatingLoader] = useState(false);

  const getCoachRatingCall = () => {
    setRatingLoader(true);
    console.log("coachId", coachId);
    if (coachId || coach_id) {
      dispatch(
        GetCoachRating({
          module: "getRatingsAndFeedback",
          postData: {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            entity_id: role === "provider" ? coachId : coach_id,
            entity_type: "coach",
          },
        })
      );
    }
  };

  const profileAPICall = () => {
    dispatch(
      userDetailBroker({
        module: "getOrderDetailBroker",
        apiToken: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
      })
    );
  };

  const coachDetailAPI = () => {
    dispatch(
      coachingDetail({
        module: "coachingDetail",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          type: "coach",
          coach_id: coach_id,
        },
      })
    );
  };

  useEffect(() => {
    setLoader(true);
    if (role === "provider") {
      // Call the API specific to providers.
      profileAPICall();
    } else {
      // Call the coachingDetail API for non-provider roles.
      coachDetailAPI();
    }
  }, [coach_id, dispatch]);

  useEffect(() => {
    if (role === "provider") {
      if (!_.isEmpty(userDetailBrokerResponse)) {
        if (userDetailBrokerResponse?.status === "success") {
          const listData = userDetailBrokerResponse;

          setCoachData(listData?.payload?.payload?.coach_info);
          setCoachId(listData?.payload?.payload?.coach_info?.user_id);
          setBanner(listData?.payload?.payload?.user_cover_image);

          // console.log(
          //   "listdate",
          //   listData?.payload?.payload?.coach_info?.user_id
          // );
          setLoader(false);
        }
      }
    } else if (!_.isEmpty(coachingDetailResponse)) {
      if (coachingDetailResponse?.status === "success") {
        const listData = coachingDetailResponse;
        console.log("coachingDetailResponse--", coachingDetailResponse);
        // setCoachData(listData?.payload?.payload[0]?.partner)
        const coachInfo = listData?.payload?.payload;
        setBanner(coachInfo?.banner);
        setCoachData({
          userId: coachInfo?.user_id,
          productId: coachInfo?.product_id,
          display_name: coachInfo?.display_name,
          language_data: coachInfo?.user_language,
          designation: coachInfo?.designation,
          experience: coachInfo?.experience,
          bio: coachInfo?.bio,
          thumbnail: coachInfo?.profile_image,
          user_industry: coachInfo?.user_industry,
          linkedin: coachInfo?.linkedIn,
          x_link: coachInfo?.twitter,
          provider_description: coachInfo?.bio,
          skill: coachInfo?.user_skill,
          availability: coachInfo?.availability,
          program_offered: coachInfo?.program_offered,
          professional_experience: coachInfo?.professional_experience,
          certifications: coachInfo?.certifications,
          purchased_info: coachInfo?.purchased_info,
          slots_booked: coachInfo?.slots_booked,
          priceInfo: !_.isEmpty(coachInfo?.purchased_info)
            ? getProcureInfo(coachInfo?.purchased_info)
            : {},
          service_slots: coachInfo?.service_slots,
          master_price_id: coachInfo?.purchased_info?.coach_price_master_id,
          designation: coachInfo?.designation,
          expertise: coachInfo?.user_expertise,
        });

        // console.log("listdate", coachData);
        setLoader(false);
        return () => {
          dispatch(coachingDetailClear());
        };
      }
    }
  }, [coachingDetailResponse, userDetailBrokerResponse]);

  useEffect(() => {
    console.log(
      "RatingAndFeedbackResponse:",
      RatingAndFeedbackResponse,
      coach_id
    );
    if (!_.isEmpty(RatingAndFeedbackResponse)) {
      // setLoader(false);
      if (RatingAndFeedbackResponse?.status === "success") {
        let list = RatingAndFeedbackResponse?.payload?.payload;
        list = list.filter((item) => item?.remark);
        setRatingFeedbackList(list);
        // dispatch(getSessionNotesClear());
      } else {
        setRatingFeedbackList([]);
      }
      setRatingLoader(false);
    }
  }, [RatingAndFeedbackResponse]);

  const capitalizeName = (name) => {
    if (!name) return "";
    return name
      .split(" ") // Split the name into parts by spaces
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1)) // Capitalize the first letter of each part
      .join(" "); // Join the parts back together
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const backgroundStyle = {
    backgroundImage: banner
      ? `url(${banner})`
      : "url('/images/banner-profile.png')",
    backgroundSize: "cover", // Adjusts the size of the image
    backgroundPosition: "right", // Centers the image
    height: "12.5625rem", // Sets the height of the container
    width: "100%", // Sets the width of the container
    backgroundColor: "#B8DBE2",
  };
  const settings = {
    arrows: true,
    dots: true, // Display navigation dots
    infinite: false, // Loop the slides infinitely
    speed: 500, // Animation speed in milliseconds
    slidesToShow: 3, // Number of slides to show at once
    slidesToScroll: 1, // Number of slides to scroll at a time
    autoplay: false, // Autoplay slides
    autoplaySpeed: 3000, // Autoplay interval in milliseconds
    centerMode: false, // Prevents centering
    centerPadding: 0, // Removes extra spacing
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <Page>
      <>
        <Loader start={loader} />
        <section className="coach-detail-sec">
          <div className="banner-detail" style={backgroundStyle}></div>
          <div className="coach-detail-header">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  {userRole !== "provider" && (
                    <button
                      className="mb-4 bck-btn detail-bk-btn"
                      onClick={() => navigate(-1)}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10"
                        height="17"
                        viewBox="0 0 10 17"
                        fill="none"
                      >
                        <path
                          d="M7.42188 16.6262L0.273438 9.16523C0.078125 8.93086 0 8.69649 0 8.46211C0 8.2668 0.078125 8.03242 0.234375 7.83711L7.38281 0.376169C7.73438 -0.0144556 8.35938 -0.0144556 8.71094 0.337107C9.10156 0.688669 9.10156 1.27461 8.75 1.66523L2.22656 8.46211L8.78906 15.3371C9.14062 15.6887 9.14062 16.3137 8.75 16.6652C8.39844 17.0168 7.77344 17.0168 7.42188 16.6262Z"
                          fill="black"
                        />
                      </svg>{" "}
                      {t("back")}
                    </button>
                  )}
                  <div className="d-flex gap-3 align-items-center align-items-md-start justify-content-between pf-sectio flex-md-row flex-column">
                    <div className="profile-box-coach">
                      <img
                        src={
                          coachData?.thumbnail
                            ? coachData?.thumbnail
                            : "/images/avatar.svg"
                        }
                        alt="Profile"
                      />
                    </div>
                    <div className="btn-box-fr d-flex gap-3">
                      {coachData?.slots_booked && (
                        <button
                          className="btn-primary d-flex gap-2 align-self-start mt-4"
                          onClick={handleShow}
                        >
                          {t("Rate Your Coach")}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="21"
                            height="21"
                            viewBox="0 0 21 21"
                            fill="none"
                          >
                            <g clip-path="url(#clip0_3328_67950)">
                              <path
                                d="M4.97643 19.998C4.7573 19.998 4.53971 19.9296 4.354 19.7953C4.00808 19.5446 3.84648 19.1137 3.94063 18.6979L5.22729 13.0302L0.863771 9.20349C0.543023 8.92349 0.420491 8.48005 0.552178 8.07431C0.683865 7.66933 1.04215 7.38261 1.46636 7.3434L7.23982 6.81925L9.52244 1.47746C9.69075 1.085 10.0741 0.831543 10.4999 0.831543C10.9258 0.831543 11.3091 1.085 11.4774 1.47655L13.7601 6.81925L19.5326 7.3434C19.9577 7.3817 20.316 7.66933 20.4477 8.07431C20.5794 8.47929 20.4576 8.92349 20.1369 9.20349L15.7734 13.0294L17.06 18.697C17.1543 19.1137 16.9926 19.5446 16.6468 19.7946C16.3018 20.0445 15.8417 20.0638 15.4784 19.8454L10.4999 16.8703L5.52148 19.8471C5.35317 19.947 5.16564 19.998 4.97643 19.998ZM10.4999 15.5887C10.6892 15.5887 10.8765 15.6395 11.045 15.7395L15.7435 18.5496L14.5291 13.2002C14.4425 12.8195 14.5717 12.422 14.8659 12.1644L18.986 8.55101L13.535 8.056C13.1425 8.02014 12.805 7.7734 12.6516 7.41176L10.4999 2.37074L8.34565 7.41252C8.19398 7.77172 7.85644 8.01846 7.46489 8.05432L2.01309 8.54933L6.13307 12.1627C6.42818 12.421 6.55728 12.8178 6.46984 13.1994L5.25643 18.5487L9.95489 15.7395C10.1232 15.6395 10.3107 15.5887 10.4999 15.5887ZM7.19572 6.92255C7.19572 6.92255 7.19572 6.92347 7.19481 6.92423L7.19572 6.92255ZM13.8025 6.92011L13.8034 6.92179C13.8034 6.92087 13.8034 6.92087 13.8025 6.92011Z"
                                fill="#415385"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_3328_67950">
                                <rect
                                  width="20"
                                  height="20"
                                  fill="white"
                                  transform="translate(0.5 0.402344)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </button>
                      )}
                      {role != "provider" ? (
                        <button
                          className="btn-primary d-flex gap-2 align-self-start mt-4"
                          onClick={() => {
                            scrollIntoViewWithOffset("#container-slot", 50);
                          }}
                        >
                          {t("Proceed to Book Slot")}
                          <RightArrowIcon />
                        </button>
                      ) : (
                        <button
                          class="btn-primary d-flex gap-2 align-self-start mt-4"
                          onClick={() => {
                            navigate(
                              `/profile/edit?section=edit&tab=1&user_id=${localStorage.getItem(
                                SessionKeys.USER_ID
                              )}`
                            );
                          }}
                        >
                          {t("editProfile")}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="13"
                            viewBox="0 0 12 13"
                            fill="none"
                          >
                            <path
                              d="M11.4875 0.913009C11.1519 0.588577 10.7033 0.407227 10.2365 0.407227C9.76971 0.407227 9.32116 0.588577 8.98552 0.913009L1.18552 8.71301L0.00952148 12.397L3.72352 11.197L11.4875 3.39701C11.8102 3.06166 11.9904 2.61438 11.9904 2.14901C11.9904 1.68364 11.8102 1.23636 11.4875 0.901009V0.913009ZM2.87152 10.339L2.06152 9.53501L8.79352 2.79701L9.60952 3.60701L2.87152 10.339Z"
                              fill="#415385"
                            />
                          </svg>
                        </button>
                      )}

                      {coachData?.priceInfo?.isPurchased ||
                      role === "provider" ? (
                        <button
                          class="subscriptionbtn d-flex gap-2 align-items-center mt-4"
                          onClick={() =>
                            role === "provider"
                              ? navigate(routeList.COACH_CALENDAR)
                              : ""
                          }
                        >
                          {role === "provider"
                            ? t("addSchedule")
                            : t("requestSession")}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="21"
                            viewBox="0 0 20 21"
                            fill="none"
                          >
                            <path
                              d="M15.8333 3.73578H4.16667C3.24619 3.73578 2.5 4.48197 2.5 5.40245V17.0691C2.5 17.9896 3.24619 18.7358 4.16667 18.7358H15.8333C16.7538 18.7358 17.5 17.9896 17.5 17.0691V5.40245C17.5 4.48197 16.7538 3.73578 15.8333 3.73578Z"
                              stroke="white"
                              stroke-width="1.6"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M13.3333 2.06915V5.40249"
                              stroke="white"
                              stroke-width="1.6"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M6.66675 2.06915V5.40249"
                              stroke="white"
                              stroke-width="1.6"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M2.5 8.73578H17.5"
                              stroke="white"
                              stroke-width="1.6"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </button>
                      ) : (
                        <>
                          {false && (
                            <button
                              class="btn-primary d-flex gap-2 align-self-start mt-4"
                              onClick={() => {
                                // dispatch(
                                //   cartPageDataResponse({
                                //     load: true,
                                //     productId: coachData?.productId,
                                //   })
                                // );
                                // setTimeout(() => {
                                //   navigate(routeList.PAYMENT_PAGE_PRODUCT);
                                // }, 2000);
                                // setSelectedCoachId(coachData?.user_id);
                                // setProductTitle(coachData?.product_title);
                                // setProductId(coachData?.product_id);
                                // setDisplayName(coachData?.display_name);
                                // // setActiveSlot(null);
                                // setSessionModal(true);
                                let obj = {
                                  coach_id: coachData?.userId,
                                  price:
                                    coachData?.purchased_info?.selling_price,
                                  currency_code:
                                    coachData?.purchased_info?.currency_code,
                                };
                                let jsonString = JSON.stringify(obj);
                                let encodedUrl = btoa(jsonString);
                                navigate(`/slot-booking?c=${encodedUrl}`);
                              }}
                            >
                              {t("Purchase to Book Slot")}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                              >
                                <path
                                  d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                                  stroke="#415385"
                                  stroke-width="1.66667"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                ></path>
                              </svg>
                            </button>
                          )}
                        </>
                      )}
                      {false && (
                        <button
                          class="btn-primary d-flex gap-2 align-self-start mt-4"
                          onClick={() => {}}
                          disabled
                        >
                          {t("Join Session")}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                          >
                            <path
                              d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                              stroke="#415385"
                              stroke-width="1.66667"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                          </svg>
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="d-flex gap-3 align-items-start justify-content-between profile-details-inco mt-4">
                    <div className="name-box">
                      <h1 className="profile-title">
                        {" "}
                        {capitalizeName(coachData?.display_name)}
                      </h1>
                      <div className="profilde mb-2">
                        {!_.isEmpty(coachData?.designation) &&
                          coachData?.designation}
                      </div>
                      <div className="exffpe">
                        {coachData?.experience &&
                          `${coachData?.experience} ${t("Experience")}`}
                      </div>
                    </div>
                    {!_.isEmpty(
                      coachData?.language_data || coachData?.language_id
                    ) && (
                      <div className="language-box">
                        <p className="profilehea">{t("languageKnown")}</p>
                        <ul className="profilelist ps-3 mb-0">
                          {/* <li>English (Fluent)</li>
                                                <li>Spanish (Conversational)</li> */}
                          {_.map(
                            coachData.language_data || coachData?.language_id,
                            (l) => (
                              <li key={l.id}>{l.name}</li>
                            )
                          )}
                        </ul>
                      </div>
                    )}
                    {(coachData?.linkedin || coachData?.x_link) && (
                      <div className="portfolio-box">
                        <p className="profilehea">
                          {t("Portfolio/Profile Link")}
                        </p>
                        <div className="socili d-flex gap-2">
                          {/* LinkedIn Profile */}
                          {coachData?.linkedin && (
                            <a
                              href={coachData?.linkedin}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="scollink"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="44"
                                height="44"
                                viewBox="0 0 44 44"
                                fill="none"
                              >
                                <g clip-path="url(#clip0_2345_13567)">
                                  <path
                                    d="M40.0198 0H3.98016C1.782 0 0 1.782 0 3.98016V40.0197C0 42.218 1.782 44 3.98016 44H40.0197C42.218 44 44 42.218 44 40.0197V3.98016C44 1.782 42.218 0 40.0198 0ZM13.6155 37.9925C13.6155 38.6322 13.0969 39.1508 12.4572 39.1508H7.52665C6.88692 39.1508 6.36837 38.6322 6.36837 37.9925V17.3239C6.36837 16.6842 6.88692 16.1656 7.52665 16.1656H12.4572C13.0969 16.1656 13.6155 16.6842 13.6155 17.3239V37.9925ZM9.99192 14.2173C7.40502 14.2173 5.30787 12.1202 5.30787 9.53326C5.30787 6.94636 7.40502 4.84921 9.99192 4.84921C12.5788 4.84921 14.676 6.94636 14.676 9.53326C14.676 12.1202 12.5789 14.2173 9.99192 14.2173ZM39.3823 38.0858C39.3823 38.6739 38.9054 39.1508 38.3173 39.1508H33.0265C32.4384 39.1508 31.9615 38.6739 31.9615 38.0858V28.3911C31.9615 26.9448 32.3857 22.0536 28.182 22.0536C24.9213 22.0536 24.2599 25.4015 24.1271 26.9039V38.0858C24.1271 38.6739 23.6503 39.1508 23.0621 39.1508H17.945C17.3568 39.1508 16.88 38.6739 16.88 38.0858V17.2306C16.88 16.6425 17.3568 16.1656 17.945 16.1656H23.0621C23.6502 16.1656 24.1271 16.6425 24.1271 17.2306V19.0338C25.3362 17.2193 27.133 15.8188 30.9588 15.8188C39.4308 15.8188 39.3823 23.7337 39.3823 28.0826V38.0858Z"
                                    fill="#0077B7"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_2345_13567">
                                    <rect width="44" height="44" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </a>
                          )}

                          {/* Twitter Profile */}
                          {coachData?.x_link && (
                            <a
                              href={coachData?.x_link}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="scollink"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="44"
                                height="44"
                                viewBox="0 0 44 44"
                                fill="none"
                              >
                                <g clip-path="url(#clip0_2345_13569)">
                                  <path
                                    d="M23.4714 21.2487L33.373 35.4116H29.3093L21.2294 23.8547V23.8539L20.0432 22.1574L10.6045 8.65619H14.6681L22.2851 19.5522L23.4714 21.2487Z"
                                    fill="black"
                                  />
                                  <path
                                    d="M39.2457 0H4.75429C2.12864 0 0 2.12864 0 4.75429V39.2457C0 41.8714 2.12864 44 4.75429 44H39.2457C41.8714 44 44 41.8714 44 39.2457V4.75429C44 2.12864 41.8714 0 39.2457 0ZM28.0646 37.3129L19.8882 25.4131L9.65131 37.3129H7.00557L18.7134 23.7041L7.00557 6.66455H15.9354L23.6779 17.9328L33.3715 6.66455H36.0172L24.853 19.6422H24.8523L36.9944 37.3129H28.0646Z"
                                    fill="black"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_2345_13569">
                                    <rect width="44" height="44" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </a>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                  <hr />
                  {((role === "provider" && coachData?.bio) ||
                    (role !== "provider" &&
                      coachData?.provider_description)) && (
                    <div className="infopx">
                      <h2 className="pge-tiel">{t("professionalSummary")}</h2>
                      <p
                        dangerouslySetInnerHTML={{
                          __html:
                            role === "provider"
                              ? coachData?.bio
                              : coachData?.provider_description,
                        }}
                      ></p>
                    </div>
                  )}
                  {_.isEmpty(coachData?.skill) ? (
                    " "
                  ) : (
                    <div className="infopx">
                      <h2 className="pge-tiel">{t("areasofExpertise")}</h2>
                      <ul className="experskd d-flex gap-3 w-100 flex-wrap">
                        {coachData?.skill?.map((skill, index) => (
                          <li key={index}>{skill}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                  {_.isEmpty(coachData?.professional_experience) ? (
                    ""
                  ) : (
                    <div className="infopx">
                      <h2 className="pge-tiel">
                        {t("professionalExperienceHighlights")}
                      </h2>
                      <ul className="expersk">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: coachData?.professional_experience,
                          }}
                        />
                      </ul>
                    </div>
                  )}
                  {_.isEmpty(coachData?.program_offered) &&
                  _.isEmpty(coachData?.availability) ? (
                    ""
                  ) : (
                    <div className="infopx">
                      {!_.isEmpty(coachData?.program_offered) ? (
                        <>
                          <h2 className="pge-tiel">
                            {t("Courses/ProgramsOffered")}
                          </h2>
                          <ul className="expersk">
                            <div
                              dangerouslySetInnerHTML={{
                                __html: coachData?.program_offered,
                              }}
                            />
                          </ul>
                        </>
                      ) : (
                        ""
                      )}
                      {!_.isEmpty(coachData?.availability) ? (
                        <>
                          <h4 className="pge-tiel mt-3">{t("availability")}</h4>
                          <div className="d-flex justify-content-between gap-lg-5 gap-3 prgoffer flex-wrap">
                            {coachData?.availability?.includes(
                              "live-sessions"
                            ) && (
                              <div className="d-flex gap-2 iconvox">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <g clip-path="url(#clip0_2345_13728)">
                                    <path
                                      d="M10.125 6.75C10.3321 6.75 10.5 6.58211 10.5 6.375C10.5 6.16789 10.3321 6 10.125 6C9.91789 6 9.75 6.16789 9.75 6.375C9.75 6.58211 9.91789 6.75 10.125 6.75Z"
                                      fill="black"
                                    />
                                    <path
                                      d="M13.875 6.75C14.0821 6.75 14.25 6.58211 14.25 6.375C14.25 6.16789 14.0821 6 13.875 6C13.6679 6 13.5 6.16789 13.5 6.375C13.5 6.58211 13.6679 6.75 13.875 6.75Z"
                                      fill="black"
                                    />
                                    <path
                                      d="M12 7.21875C11.9254 7.21875 11.8539 7.24838 11.8011 7.30113C11.7484 7.35387 11.7188 7.42541 11.7188 7.5V8.25C11.7188 8.32459 11.7484 8.39613 11.8011 8.44887C11.8539 8.50162 11.9254 8.53125 12 8.53125C12.0746 8.53125 12.1461 8.50162 12.1989 8.44887C12.2516 8.39613 12.2812 8.32459 12.2812 8.25V7.5C12.2812 7.42541 12.2516 7.35387 12.1989 7.30113C12.1461 7.24838 12.0746 7.21875 12 7.21875Z"
                                      fill="black"
                                    />
                                    <path
                                      d="M21.3875 2.4375H16.5633C16.1642 1.72718 15.5833 1.13579 14.8803 0.723932C14.1773 0.312079 13.3774 0.0945865 12.5626 0.09375H7.12511C7.06401 0.0937347 7.00457 0.113617 6.95578 0.150389C6.90698 0.187162 6.87149 0.238824 6.85466 0.297563L6.83306 0.373163C6.64401 1.04455 6.6048 1.74928 6.7182 2.4375H2.63745C2.1652 2.43805 1.71245 2.62589 1.37852 2.95982C1.04459 3.29375 0.856747 3.7465 0.856201 4.21875V17.7188C0.856747 18.191 1.04459 18.6438 1.37852 18.9777C1.71245 19.3116 2.1652 19.4995 2.63745 19.5H9.1062V21.9375H7.13745C7.06286 21.9375 6.99132 21.9671 6.93858 22.0199C6.88583 22.0726 6.8562 22.1442 6.8562 22.2188V23.7188C6.8562 23.7933 6.88583 23.8649 6.93858 23.9176C6.99132 23.9704 7.06286 24 7.13745 24H16.8875C16.962 24 17.0336 23.9704 17.0863 23.9176C17.1391 23.8649 17.1687 23.7933 17.1687 23.7188V22.2188C17.1687 22.1442 17.1391 22.0726 17.0863 22.0199C17.0336 21.9671 16.962 21.9375 16.8875 21.9375H14.9187V19.5H21.3875C21.8597 19.4995 22.3125 19.3116 22.6464 18.9777C22.9803 18.6438 23.1682 18.191 23.1687 17.7188V4.21875C23.1682 3.7465 22.9803 3.29375 22.6464 2.95982C22.3125 2.62589 21.8597 2.43805 21.3875 2.4375ZM7.33935 0.65625H12.5626C13.6314 0.657441 14.6561 1.08254 15.4118 1.83829C16.1676 2.59404 16.5927 3.61871 16.5939 4.6875C16.5905 4.90883 16.5649 5.12926 16.5177 5.34551C16.5117 5.34551 16.5061 5.34375 16.5001 5.34375H16.0314V4.875C16.0314 4.80041 16.0017 4.72887 15.949 4.67613C15.8962 4.62338 15.8247 4.59375 15.7501 4.59375H15.6069C15.2295 4.59288 14.8573 4.50457 14.5197 4.33576C14.1821 4.16694 13.8882 3.9222 13.6611 3.62074L13.3501 3.20625C13.3275 3.1761 13.299 3.15081 13.2665 3.13187C13.2339 3.11293 13.1978 3.10074 13.1604 3.09601C13.123 3.09128 13.0851 3.09411 13.0488 3.10434C13.0125 3.11457 12.9787 3.13198 12.9493 3.15555C11.7845 4.08487 10.339 4.59186 8.84888 4.59375H8.37671C7.88605 4.07799 7.53368 3.44661 7.35233 2.75823C7.17097 2.06986 7.16651 1.34681 7.33935 0.65625ZM16.9689 6.375V7.875C16.9688 7.99929 16.9193 8.11845 16.8314 8.20634C16.7436 8.29422 16.6244 8.34364 16.5001 8.34375H15.9402C16.0003 8.06652 16.0309 7.78369 16.0314 7.5V5.90625H16.5001C16.6244 5.90636 16.7436 5.95578 16.8314 6.04366C16.9193 6.13155 16.9688 6.25071 16.9689 6.375ZM10.5001 10.5938H9.37511C9.25079 10.5938 9.13157 10.5444 9.04366 10.4565C8.95575 10.3685 8.90636 10.2493 8.90636 10.125C8.90636 10.0007 8.95575 9.88145 9.04366 9.79354C9.13157 9.70564 9.25079 9.65625 9.37511 9.65625H10.5001C10.6244 9.65625 10.7437 9.70564 10.8316 9.79354C10.9195 9.88145 10.9689 10.0007 10.9689 10.125C10.9689 10.2493 10.9195 10.3685 10.8316 10.4565C10.7437 10.5444 10.6244 10.5938 10.5001 10.5938ZM11.7324 11.5227C11.8232 11.5285 11.9136 11.5314 12.0036 11.5314C12.4826 11.5313 12.9576 11.4456 13.4064 11.2781V11.8125C13.4064 12.1855 13.2582 12.5431 12.9945 12.8069C12.7308 13.0706 12.3731 13.2188 12.0001 13.2188C11.6272 13.2188 11.2695 13.0706 11.0057 12.8069C10.742 12.5431 10.5939 12.1855 10.5939 11.8125V11.2711C10.9584 11.4124 11.3423 11.4972 11.7324 11.5227ZM12.0001 13.7812C12.4119 13.7798 12.8128 13.6491 13.1463 13.4075C13.4798 13.1659 13.7289 12.8256 13.8585 12.4348L16.5923 13.4599C17.1495 13.6711 17.6533 14.0026 18.0677 14.4309C18.4821 14.8591 18.7969 15.3736 18.9896 15.9375H5.0106C5.20329 15.3736 5.51805 14.8592 5.93243 14.4309C6.3468 14.0026 6.85058 13.6711 7.40783 13.4599L10.1416 12.4348C10.2712 12.8257 10.5204 13.1659 10.8538 13.4075C11.1873 13.6491 11.5883 13.7799 12.0001 13.7812ZM11.7687 10.9613C11.579 10.948 11.3909 10.9183 11.2064 10.8726C11.357 10.7313 11.4616 10.548 11.5066 10.3465C11.5516 10.145 11.5349 9.93463 11.4587 9.74274C11.3825 9.55085 11.2504 9.38633 11.0794 9.27058C10.9084 9.15484 10.7066 9.09322 10.5001 9.09375H9.37511C9.25064 9.09457 9.12737 9.11814 9.01136 9.16327C8.70012 8.61714 8.5348 8.00004 8.53136 7.37145V5.15625H8.84888C10.3674 5.15426 11.846 4.66913 13.0706 3.77108L13.211 3.95839C13.4768 4.31085 13.8168 4.60056 14.207 4.807C14.5971 5.01343 15.028 5.13154 15.4689 5.15295V7.5C15.4689 7.97503 15.3713 8.44499 15.1822 8.88076C14.9931 9.31653 14.7165 9.70883 14.3696 10.0333C14.0227 10.3578 13.6129 10.6076 13.1655 10.7673C12.7181 10.9269 12.2426 10.9929 11.7687 10.9613ZM8.08436 8.34375H7.50011C7.37583 8.34364 7.25666 8.29422 7.16878 8.20634C7.08089 8.11845 7.03147 7.99929 7.03136 7.875V6.375C7.03147 6.25071 7.08089 6.13155 7.16878 6.04366C7.25666 5.95578 7.37583 5.90636 7.50011 5.90625H7.96886V7.37145C7.96938 7.69894 8.00814 8.02525 8.08436 8.34375ZM7.40636 8.89676C7.43771 8.89965 7.46801 8.90625 7.50011 8.90625H8.25953C8.34139 9.11458 8.43947 9.31617 8.55285 9.50917C8.4778 9.60964 8.42186 9.72305 8.38785 9.84375H7.87511C7.75083 9.84364 7.63166 9.79422 7.54378 9.70634C7.45589 9.61845 7.40647 9.49929 7.40636 9.375V8.89676ZM1.4187 4.21875C1.41908 3.89563 1.5476 3.58586 1.77608 3.35738C2.00456 3.1289 2.31433 3.00038 2.63745 3H6.84229C7.05206 3.74312 7.43859 4.42442 7.96886 4.9857V5.34375H7.50011C7.2267 5.34406 6.96458 5.45281 6.77125 5.64614C6.57792 5.83947 6.46917 6.10159 6.46886 6.375V7.875C6.46941 8.02599 6.50331 8.17499 6.56813 8.31135C6.63296 8.44771 6.72711 8.56807 6.84386 8.66381V9.375C6.84414 9.64842 6.95288 9.91056 7.14622 10.1039C7.33955 10.2972 7.60169 10.406 7.87511 10.4062H8.38778C8.44848 10.6216 8.57769 10.8113 8.75585 10.9466C8.934 11.0819 9.15139 11.1555 9.37511 11.1562H10.0314V11.8125C10.0314 11.8333 10.0368 11.8526 10.0375 11.8732L7.21043 12.9333C6.54498 13.185 5.94673 13.5871 5.46241 14.1082C4.97808 14.6294 4.6208 15.2554 4.41848 15.9375H1.4187V4.21875ZM16.6062 22.5V23.4375H7.4187V22.5H16.6062ZM9.6687 21.9375V19.5H14.3562V21.9375H9.6687ZM22.6062 17.7188C22.6058 18.0419 22.4773 18.3516 22.2488 18.5801C22.0203 18.8086 21.7106 18.9371 21.3875 18.9375H2.63745C2.31433 18.9371 2.00456 18.8086 1.77608 18.5801C1.5476 18.3516 1.41908 18.0419 1.4187 17.7188V16.5H22.6062V17.7188ZM22.6062 15.9375H19.5818C19.3794 15.2554 19.0221 14.6294 18.5378 14.1082C18.0535 13.5871 17.4552 13.185 16.7898 12.9333L13.9627 11.8732C13.9634 11.8526 13.9689 11.8333 13.9689 11.8125V11.0154C14.8041 10.5524 15.444 9.80343 15.7712 8.90625H16.5001C16.7735 8.90594 17.0356 8.79719 17.229 8.60386C17.4223 8.41053 17.5311 8.14841 17.5314 7.875V6.375C17.5311 6.20254 17.4875 6.03291 17.4046 5.88169C17.3217 5.73046 17.2021 5.6025 17.0568 5.50954C17.119 5.23982 17.1524 4.96426 17.1564 4.6875C17.1558 4.10948 17.0454 3.53683 16.8311 3H21.3873C21.7105 3.00038 22.0202 3.1289 22.2487 3.35738C22.4772 3.58586 22.6057 3.89563 22.6061 4.21875L22.6062 15.9375Z"
                                      fill="black"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_2345_13728">
                                      <rect
                                        width="24"
                                        height="24"
                                        fill="white"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                                {t("liveSessionsInPersonOrVirtual")}
                              </div>
                            )}
                            {coachData?.availability?.includes(
                              "one-to-one"
                            ) && (
                              <div className="d-flex gap-2 iconvox">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <g clip-path="url(#clip0_2345_13743)">
                                    <path
                                      d="M14.2883 5.22772H19.6472C19.9061 5.22772 20.116 5.01782 20.116 4.75897C20.116 4.50013 19.9061 4.29022 19.6472 4.29022H14.2883C14.0294 4.29022 13.8196 4.50013 13.8196 4.75897C13.8196 5.01782 14.0294 5.22772 14.2883 5.22772Z"
                                      fill="black"
                                    />
                                    <path
                                      d="M14.2883 3.16522H19.6472C19.9061 3.16522 20.116 2.95532 20.116 2.69647C20.116 2.43763 19.9061 2.22772 19.6472 2.22772H14.2883C14.0294 2.22772 13.8196 2.43763 13.8196 2.69647C13.8196 2.95532 14.0294 3.16522 14.2883 3.16522Z"
                                      fill="black"
                                    />
                                    <path
                                      d="M22.0425 18.6L20.0168 17.9789C20.6721 17.373 21.0833 16.5068 21.0833 15.546V14.1727C21.0833 13.1034 20.5738 12.1512 19.7853 11.5448V7.44206C21.6986 7.2863 23.2081 5.6805 23.2081 3.72778C23.2081 1.67227 21.5358 0 19.4804 0H14.4555C12.6 0 11.0573 1.3627 10.7745 3.13973H3.51562C2.22328 3.13973 1.17188 4.19114 1.17188 5.48348V14.9062H0.46875C0.209859 14.9062 0 15.1161 0 15.3749V16.7509C0 17.6469 0.728906 18.3758 1.62492 18.3758H5.85684C6.11573 18.3758 6.32559 18.1659 6.32559 17.907C6.32559 17.6482 6.11573 17.4383 5.85684 17.4383H1.62492C1.24589 17.4383 0.9375 17.13 0.9375 16.7509V15.8437H14.468C14.5207 16.4329 14.7282 16.978 15.0495 17.4383H10.0756C9.8167 17.4383 9.60684 17.6483 9.60684 17.9071C9.60684 18.1659 9.8167 18.3758 10.0756 18.3758H14.2122L13.4905 18.5984C12.3222 18.9586 11.5373 20.022 11.5373 21.2446V23.5312C11.5373 23.7901 11.7471 24 12.006 24H23.5312C23.7901 24 24 23.7901 24 23.5312V21.2475C24 20.0229 23.2133 18.9589 22.0425 18.6ZM20.1458 14.1727V15.546C20.1458 16.8568 19.0794 17.9232 17.7686 17.9232C16.4579 17.9232 15.3915 16.8568 15.3915 15.546V14.1727C15.3915 12.862 16.4579 11.7956 17.7686 11.7956C19.0794 11.7956 20.1458 12.862 20.1458 14.1727ZM14.4555 0.9375H19.4803C21.0189 0.9375 22.2706 2.1892 22.2706 3.72773C22.2706 5.26631 21.0189 6.51802 19.4803 6.51802H16.3721C16.1565 6.51802 15.9688 6.66502 15.917 6.87422C15.7966 7.36111 15.3482 7.79508 14.8076 8.01155C14.901 7.65736 14.9398 7.31142 14.9256 6.96745C14.9152 6.71634 14.7068 6.51806 14.4554 6.51806C12.9169 6.51806 11.6652 5.26636 11.6652 3.72778C11.6652 2.1892 12.9169 0.9375 14.4555 0.9375ZM11.7158 14.9062H10.6611V13.9197C10.6611 13.6608 10.4512 13.4509 10.1923 13.4509C9.93342 13.4509 9.72356 13.6608 9.72356 13.9197V14.9062H6.1845V13.9197C6.1845 13.6608 5.97464 13.4509 5.71575 13.4509C5.45686 13.4509 5.247 13.6608 5.247 13.9197V14.9062H4.18664V13.6951C4.18664 13.1559 4.53281 12.687 5.04797 12.5281L7.086 11.8996C7.21308 11.951 7.34545 11.9918 7.48242 12.0201V12.6888C7.48242 12.9477 7.69228 13.1576 7.95117 13.1576C8.21006 13.1576 8.41992 12.9477 8.41992 12.6888V12.0201C8.55398 11.9925 8.68355 11.9527 8.80809 11.9029L10.8525 12.5296C11.3688 12.688 11.7157 13.1572 11.7157 13.6973V14.9062H11.7158ZM8.75948 7.536C8.26045 7.95998 7.29305 8.24498 6.2138 8.2898C6.14742 7.8682 6.23541 7.44356 6.46805 7.07789C6.73209 6.66286 7.14375 6.38428 7.62727 6.29367C7.7347 6.27347 7.84294 6.26339 7.95117 6.26339C8.05941 6.26339 8.16764 6.27347 8.27512 6.29367C8.75864 6.38433 9.1703 6.66286 9.43434 7.07789C9.597 7.33359 9.68897 7.61812 9.70692 7.90997C9.60966 7.78523 9.5033 7.66688 9.38864 7.55611C9.2153 7.38863 8.94319 7.37991 8.75948 7.536ZM9.3323 9.1448V9.74911C9.3323 10.5106 8.71275 11.1302 7.95122 11.1302C7.18964 11.1302 6.57009 10.5106 6.57009 9.74911V9.20705C7.52198 9.12938 8.37886 8.88431 8.99123 8.51709C9.13664 8.70952 9.25209 8.92158 9.3323 9.1448ZM14.4539 14.1727V14.9062H12.6532V13.6973C12.6532 12.7426 12.04 11.9131 11.1273 11.6333L9.7493 11.2109C10.0613 10.8278 10.2531 10.3436 10.2681 9.81581L10.561 8.69428C10.7467 7.97452 10.6243 7.20192 10.2254 6.57473C9.82641 5.94745 9.1785 5.50917 8.44791 5.37216C8.11833 5.31042 7.78406 5.31033 7.45453 5.37216C6.72389 5.50917 6.07603 5.94745 5.67703 6.57473C5.27808 7.20192 5.15573 7.97447 5.34173 8.69569L5.63428 9.81581C5.64928 10.342 5.83997 10.8247 6.15019 11.2072L4.77169 11.6322C3.861 11.913 3.24914 12.7421 3.24914 13.6951V14.9062H2.10938V5.48348C2.10938 4.70808 2.74022 4.07723 3.51562 4.07723H10.744C10.9057 5.80828 12.2562 7.19934 13.9698 7.42388C13.9281 7.7423 13.8247 8.07291 13.6575 8.42452C13.5885 8.56978 13.5987 8.74022 13.6846 8.8762C13.7705 9.01219 13.92 9.09459 14.0809 9.09459C15.2064 9.09459 16.2869 8.39869 16.7048 7.45556H18.8478V11.0394C18.5093 10.9225 18.1464 10.8581 17.7686 10.8581C15.9409 10.8581 14.4539 12.345 14.4539 14.1727ZM23.0625 23.0625H12.4747V21.2446C12.4747 20.436 12.9939 19.7325 13.7667 19.4942L16.5618 18.6322C16.936 18.7791 17.3429 18.8607 17.7686 18.8607C18.19 18.8607 18.593 18.7808 18.9641 18.6367L21.7676 19.4963C22.5421 19.7337 23.0625 20.4375 23.0625 21.2475V23.0625Z"
                                      fill="black"
                                    />
                                    <path
                                      d="M7.96606 18.376C8.22495 18.376 8.43481 18.1661 8.43481 17.9072C8.43481 17.6483 8.22495 17.4385 7.96606 17.4385C7.70718 17.4385 7.49731 17.6483 7.49731 17.9072C7.49731 18.1661 7.70718 18.376 7.96606 18.376Z"
                                      fill="black"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_2345_13743">
                                      <rect
                                        width="24"
                                        height="24"
                                        fill="white"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                                {t("OneonOneCoaching")}
                              </div>
                            )}
                            {coachData?.availability?.includes("webinar") && (
                              <div className="d-flex gap-2 iconvox">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <g clip-path="url(#clip0_2345_13759)">
                                    <path
                                      d="M11.5111 16.869C11.3575 16.869 11.2074 16.9145 11.0797 16.9999C10.952 17.0852 10.8525 17.2064 10.7937 17.3483C10.735 17.4902 10.7196 17.6463 10.7495 17.7969C10.7795 17.9475 10.8534 18.0859 10.962 18.1945C11.0706 18.3031 11.209 18.377 11.3596 18.407C11.5102 18.4369 11.6663 18.4216 11.8082 18.3628C11.9501 18.304 12.0713 18.2045 12.1566 18.0768C12.242 17.9491 12.2875 17.799 12.2875 17.6455C12.2873 17.4396 12.2054 17.2423 12.0598 17.0967C11.9143 16.9511 11.7169 16.8693 11.5111 16.869ZM11.5111 17.9531C11.4502 17.9531 11.3907 17.9351 11.3401 17.9013C11.2895 17.8675 11.2501 17.8194 11.2268 17.7632C11.2035 17.707 11.1974 17.6451 11.2093 17.5854C11.2211 17.5258 11.2505 17.4709 11.2935 17.4279C11.3365 17.3849 11.3913 17.3556 11.451 17.3437C11.5107 17.3318 11.5726 17.3379 11.6288 17.3612C11.685 17.3845 11.7331 17.4239 11.7669 17.4745C11.8007 17.5251 11.8187 17.5846 11.8187 17.6455C11.8186 17.727 11.7862 17.8052 11.7285 17.8629C11.6708 17.9206 11.5926 17.953 11.5111 17.9531Z"
                                      fill="black"
                                    />
                                    <path
                                      d="M13.1415 11.4901C13.1732 11.5009 13.2071 11.504 13.2403 11.4991C13.2734 11.4942 13.3049 11.4814 13.3322 11.4619C13.3595 11.4424 13.3817 11.4167 13.397 11.3868C13.4123 11.357 13.4203 11.324 13.4203 11.2904V10.0106C13.4203 9.97709 13.4123 9.94405 13.397 9.91423C13.3817 9.88441 13.3595 9.85868 13.3322 9.83916C13.3049 9.81964 13.2734 9.80689 13.2403 9.80198C13.2071 9.79708 13.1732 9.80014 13.1415 9.81093L12.4595 10.0428V9.7796C12.4595 9.72366 12.4373 9.67001 12.3977 9.63045C12.3582 9.59089 12.3045 9.56866 12.2486 9.56866H10.5529C10.4077 9.56883 10.2684 9.6266 10.1658 9.72931C10.0631 9.83201 10.0053 9.97125 10.0051 10.1165V11.1639C10.0053 11.3092 10.0631 11.4484 10.1658 11.5511C10.2684 11.6538 10.4077 11.7116 10.5529 11.7118H12.2486C12.3045 11.7118 12.3582 11.6895 12.3977 11.65C12.4373 11.6104 12.4595 11.5568 12.4595 11.5008V11.2583L13.1415 11.4901ZM12.4652 10.4864L12.9984 10.3051V10.9959L12.4652 10.8146V10.4864ZM12.0376 11.2899H10.5529C10.5195 11.2898 10.4875 11.2765 10.4639 11.2529C10.4403 11.2293 10.427 11.1973 10.427 11.1639V10.1165C10.427 10.0831 10.4403 10.0511 10.4639 10.0275C10.4875 10.0039 10.5195 9.99057 10.5529 9.99053H12.0376V11.2899Z"
                                      fill="black"
                                    />
                                    <path
                                      d="M6.23012 4.19853C6.27838 4.19858 6.32521 4.18212 6.36283 4.15188C6.38622 4.13309 6.94849 3.69494 8.00638 3.97287C8.03327 3.98022 8.06135 3.98217 8.089 3.9786C8.11664 3.97503 8.14331 3.96602 8.16745 3.95208C8.19159 3.93815 8.21273 3.91956 8.22965 3.89741C8.24656 3.87525 8.25892 3.84996 8.266 3.823C8.27309 3.79604 8.27476 3.76795 8.27092 3.74034C8.26708 3.71273 8.2578 3.68615 8.24363 3.66215C8.22946 3.63815 8.21067 3.61719 8.18835 3.60049C8.16603 3.5838 8.14062 3.57169 8.11359 3.56487C6.83442 3.22855 6.12438 3.80155 6.09476 3.82609C6.0615 3.85384 6.03759 3.89117 6.02631 3.93299C6.01503 3.97482 6.01692 4.01911 6.03171 4.05982C6.04651 4.10054 6.0735 4.1357 6.109 4.16052C6.14451 4.18534 6.1868 4.19861 6.23012 4.19853Z"
                                      fill="black"
                                    />
                                    <path
                                      d="M6.23012 5.15839C6.27839 5.15843 6.32521 5.14197 6.36283 5.11174C6.38622 5.09292 6.94849 4.65478 8.00639 4.93273C8.03328 4.94008 8.06135 4.94203 8.089 4.93846C8.11665 4.93489 8.14331 4.92588 8.16745 4.91194C8.19159 4.89801 8.21273 4.87942 8.22965 4.85727C8.24657 4.83511 8.25892 4.80982 8.26601 4.78286C8.27309 4.7559 8.27476 4.72781 8.27092 4.7002C8.26708 4.67259 8.25781 4.64601 8.24363 4.62201C8.22946 4.59801 8.21067 4.57705 8.18835 4.56035C8.16603 4.54366 8.14062 4.53155 8.11359 4.52473C6.83442 4.18836 6.12438 4.76139 6.09476 4.78595C6.0615 4.8137 6.0376 4.85103 6.02631 4.89285C6.01503 4.93468 6.01692 4.97897 6.03171 5.01968C6.04651 5.0604 6.0735 5.09556 6.10901 5.12038C6.14451 5.1452 6.1868 5.15847 6.23012 5.15839Z"
                                      fill="black"
                                    />
                                    <path
                                      d="M6.23012 6.16288C6.27839 6.16293 6.32521 6.14647 6.36283 6.11623C6.38622 6.09742 6.94849 5.65925 8.00639 5.93723C8.03328 5.94458 8.06135 5.94652 8.089 5.94295C8.11665 5.93939 8.14331 5.93037 8.16745 5.91644C8.19159 5.9025 8.21273 5.88392 8.22965 5.86176C8.24657 5.83961 8.25892 5.81432 8.26601 5.78736C8.27309 5.7604 8.27476 5.7323 8.27092 5.70469C8.26708 5.67708 8.25781 5.65051 8.24363 5.62651C8.22946 5.6025 8.21067 5.58155 8.18835 5.56485C8.16603 5.54815 8.14062 5.53604 8.11359 5.52922C6.83442 5.19291 6.12438 5.76591 6.09476 5.79044C6.0615 5.81819 6.0376 5.85552 6.02631 5.89735C6.01503 5.93917 6.01692 5.98346 6.03171 6.02418C6.04651 6.06489 6.0735 6.10005 6.10901 6.12487C6.14451 6.14969 6.1868 6.16297 6.23012 6.16288Z"
                                      fill="black"
                                    />
                                    <path
                                      d="M2.45891 3.97288C3.51438 3.69548 4.0766 4.13118 4.10235 4.15175C4.14553 4.18732 4.20108 4.20427 4.25676 4.19889C4.31245 4.1935 4.36371 4.16621 4.39928 4.12303C4.43484 4.07984 4.4518 4.0243 4.44641 3.96861C4.44102 3.91293 4.41374 3.86166 4.37055 3.8261C4.34093 3.80156 3.6308 3.22854 2.35172 3.56488C2.32469 3.5717 2.29928 3.58381 2.27696 3.6005C2.25464 3.6172 2.23585 3.63816 2.22168 3.66216C2.20751 3.68616 2.19823 3.71274 2.19439 3.74035C2.19055 3.76796 2.19222 3.79605 2.19931 3.82301C2.20639 3.84997 2.21875 3.87526 2.23567 3.89742C2.25258 3.91957 2.27372 3.93816 2.29786 3.95209C2.322 3.96603 2.34867 3.97504 2.37631 3.97861C2.40396 3.98218 2.43202 3.98023 2.45891 3.97288Z"
                                      fill="black"
                                    />
                                    <path
                                      d="M2.45893 4.93271C3.5138 4.65544 4.07598 5.0905 4.1023 5.11154C4.14548 5.14711 4.20102 5.16407 4.2567 5.15869C4.31239 5.15331 4.36366 5.12604 4.39923 5.08286C4.4348 5.03968 4.45177 4.98414 4.44639 4.92845C4.44101 4.87277 4.41373 4.8215 4.37055 4.78593C4.34093 4.76139 3.6308 4.18839 2.35172 4.52471C2.32469 4.53153 2.29928 4.54363 2.27696 4.56033C2.25464 4.57703 2.23585 4.59799 2.22168 4.62199C2.20751 4.64599 2.19823 4.67257 2.19439 4.70018C2.19055 4.72779 2.19222 4.75588 2.19931 4.78284C2.20639 4.8098 2.21875 4.83509 2.23567 4.85725C2.25258 4.8794 2.27372 4.89798 2.29786 4.91192C2.322 4.92586 2.34867 4.93487 2.37631 4.93844C2.40396 4.94201 2.43204 4.94006 2.45893 4.93271Z"
                                      fill="black"
                                    />
                                    <path
                                      d="M2.45893 5.93722C3.5138 5.65995 4.07598 6.09501 4.1023 6.11605C4.14548 6.15162 4.20102 6.16858 4.2567 6.1632C4.31239 6.15783 4.36366 6.13055 4.39923 6.08737C4.4348 6.04419 4.45177 5.98865 4.44639 5.93296C4.44101 5.87728 4.41373 5.82601 4.37055 5.79044C4.34093 5.76588 3.6308 5.19292 2.35172 5.52922C2.32469 5.53604 2.29928 5.54815 2.27696 5.56484C2.25464 5.58154 2.23585 5.6025 2.22168 5.6265C2.20751 5.65051 2.19823 5.67708 2.19439 5.70469C2.19055 5.7323 2.19222 5.76039 2.19931 5.78735C2.20639 5.81431 2.21875 5.8396 2.23567 5.86176C2.25258 5.88391 2.27372 5.9025 2.29786 5.91643C2.322 5.93037 2.34867 5.93938 2.37631 5.94295C2.40396 5.94652 2.43204 5.94457 2.45893 5.93722Z"
                                      fill="black"
                                    />
                                    <path
                                      d="M22.9632 3.95673H22.6435C22.6064 3.59699 22.4374 3.26373 22.169 3.02129C21.9007 2.77885 21.552 2.64441 21.1904 2.64392H10.1236V1.72001C10.1232 1.57294 10.0694 1.43103 9.97222 1.32061C9.87507 1.21019 9.74118 1.13875 9.59537 1.11954C9.53275 1.11151 9.37705 1.10629 9.2324 1.10401C9.22521 1.00854 9.18622 0.918237 9.12167 0.847533C9.05711 0.776829 8.97071 0.729808 8.87629 0.713985C8.12235 0.586517 6.27299 0.409799 5.38625 1.52056C5.36977 1.54172 5.34867 1.55883 5.32457 1.5706C5.30047 1.58238 5.27401 1.58849 5.24719 1.58849C5.22036 1.58849 5.1939 1.58238 5.1698 1.5706C5.1457 1.55883 5.1246 1.54172 5.10812 1.52056C4.22158 0.409724 2.37222 0.586377 1.61823 0.713956C1.52375 0.729774 1.43731 0.776828 1.37274 0.847588C1.30817 0.918348 1.2692 1.00872 1.26207 1.10425C1.11451 1.10666 0.959257 1.1118 0.899131 1.11951C0.753261 1.13859 0.619283 1.20999 0.52211 1.32044C0.424938 1.43089 0.371186 1.57287 0.37085 1.71998V7.3117C0.37085 7.31461 0.371248 7.31747 0.371318 7.32037V16.0746C0.371318 16.0752 0.371145 16.0758 0.371145 16.0764C0.371145 16.077 0.371309 16.0775 0.371318 16.0781V17.9833C0.37169 18.3706 0.525682 18.7419 0.799508 19.0158C1.07333 19.2898 1.44463 19.4439 1.83194 19.4444H9.75927L9.28463 22.912H8.16005C8.09789 22.912 8.03828 22.9367 7.99433 22.9807C7.95037 23.0246 7.92568 23.0842 7.92568 23.1464C7.92568 23.2086 7.95037 23.2682 7.99433 23.3121C8.03828 23.3561 8.09789 23.3808 8.16005 23.3808H14.9511C15.0133 23.3808 15.0729 23.3561 15.1169 23.3121C15.1608 23.2682 15.1855 23.2086 15.1855 23.1464C15.1855 23.0842 15.1608 23.0246 15.1169 22.9807C15.0729 22.9367 15.0133 22.912 14.9511 22.912H13.8265L13.3519 19.4444H21.1904C21.5777 19.4439 21.949 19.2898 22.2228 19.0158C22.4966 18.7419 22.6506 18.3706 22.651 17.9833V16.0786C22.651 16.0779 22.6512 16.0771 22.6512 16.0764C22.6512 16.0756 22.651 16.0749 22.651 16.0741V7.26171H22.9632C23.1397 7.26152 23.3089 7.19131 23.4337 7.0665C23.5585 6.94168 23.6287 6.77246 23.6289 6.59594V4.62248C23.6287 4.44597 23.5585 4.27675 23.4337 4.15194C23.3089 4.02713 23.1397 3.95693 22.9632 3.95673ZM9.7578 22.912L10.2324 19.4445H12.8788L13.3534 22.912H9.7578ZM21.1903 3.11264C21.4275 3.11312 21.6567 3.1985 21.8364 3.35333C22.0161 3.50817 22.1344 3.72222 22.1699 3.95673H20.1194C19.9429 3.95693 19.7736 4.02714 19.6488 4.15195C19.524 4.27676 19.4538 4.44599 19.4536 4.6225V4.94828H10.1237V3.11266L21.1903 3.11264ZM5.71598 1.78374C6.48376 0.821919 8.27517 1.04017 8.8059 1.12993C8.80766 1.1303 8.80923 1.13127 8.81035 1.13268C8.81147 1.13409 8.81207 1.13584 8.81203 1.13764V6.61139C8.8121 6.61244 8.81191 6.61349 8.81149 6.61445C8.81106 6.61541 8.81042 6.61625 8.8096 6.61691C8.80874 6.61778 8.80768 6.61844 8.80651 6.61882C8.80534 6.6192 8.80409 6.6193 8.80288 6.6191C6.962 6.45508 5.94246 6.97766 5.45818 7.3579V1.97139C5.55946 1.93321 5.64852 1.86838 5.71598 1.78374ZM1.68245 1.13764C1.68241 1.13584 1.68301 1.13408 1.68413 1.13267C1.68525 1.13126 1.68683 1.13029 1.68859 1.12993C2.21937 1.04011 4.01078 0.821957 4.77845 1.78372C4.84592 1.86838 4.93501 1.93323 5.03631 1.97141V7.35798C4.61486 7.02698 3.78819 6.58807 2.36704 6.58807C2.15537 6.58807 1.93024 6.59782 1.69161 6.61913C1.69039 6.61929 1.68916 6.61918 1.68799 6.61879C1.68683 6.61841 1.68576 6.61777 1.68488 6.61691C1.68407 6.61625 1.68342 6.61541 1.683 6.61445C1.68258 6.61349 1.68239 6.61244 1.68245 6.61139V1.13764ZM0.792725 1.71998C0.792858 1.67539 0.809189 1.63235 0.838679 1.5989C0.868169 1.56544 0.908809 1.54384 0.953037 1.53811C0.999396 1.53209 1.1306 1.52811 1.26058 1.52626V6.61139C1.26062 6.67109 1.27308 6.73012 1.29718 6.78474C1.32129 6.83935 1.3565 6.88834 1.40058 6.9286C1.44466 6.96885 1.49664 6.99949 1.55321 7.01855C1.60978 7.03761 1.6697 7.04468 1.72915 7.03931C3.54597 6.8774 4.468 7.41848 4.85568 7.75559C4.96452 7.84949 5.10348 7.90114 5.24722 7.90114C5.39097 7.90114 5.52993 7.84949 5.63877 7.75559C6.02655 7.41848 6.94839 6.87731 8.76534 7.03931C8.82479 7.04468 8.88471 7.03761 8.94128 7.01855C8.99785 6.99949 9.04983 6.96885 9.09391 6.9286C9.13799 6.88834 9.1732 6.83935 9.1973 6.78474C9.22141 6.73012 9.23387 6.67109 9.2339 6.61139V1.52511C9.27311 1.52503 9.30339 1.52499 9.31084 1.52499C9.38792 1.52436 9.46496 1.52874 9.54146 1.53811C9.58569 1.54384 9.62633 1.56545 9.65582 1.5989C9.68531 1.63236 9.70164 1.67539 9.70178 1.71999V7.31171C9.70172 7.3367 9.69656 7.36142 9.68661 7.38435C9.67666 7.40728 9.66214 7.42793 9.64392 7.44505C9.62571 7.46217 9.60419 7.47538 9.58069 7.48389C9.55719 7.4924 9.5322 7.49601 9.50725 7.49452C7.45365 7.36093 6.2874 7.87889 5.66959 8.33733C5.54716 8.42732 5.39919 8.47585 5.24725 8.47585C5.0953 8.47585 4.94733 8.42732 4.8249 8.33733C4.27459 7.92905 3.28881 7.47296 1.62803 7.47296C1.42459 7.47296 1.211 7.48014 0.987246 7.49452C0.962334 7.49629 0.937327 7.49282 0.913834 7.48435C0.890341 7.47587 0.868883 7.46257 0.85084 7.4453C0.83244 7.42826 0.817775 7.40759 0.80777 7.3846C0.797765 7.3616 0.792639 7.33678 0.792715 7.31171L0.792725 1.71998ZM8.30717 10.8344C8.35799 11.3937 8.61594 11.9139 9.03043 12.2929C9.44491 12.672 9.98605 12.8825 10.5477 12.8832H11.3311V15.842H7.45468V15.3506C7.45814 15.0939 7.38533 14.8419 7.24548 14.6266C7.10562 14.4113 6.90501 14.2424 6.66906 14.1412C6.62917 14.1245 6.5914 14.1031 6.55656 14.0775C6.52078 14.0514 6.49098 14.0181 6.46916 13.9796C6.44733 13.9411 6.43398 13.8984 6.43 13.8543C6.42545 13.8037 6.4317 13.7528 6.44835 13.7047C6.465 13.6567 6.49166 13.6128 6.52656 13.5759C6.67515 13.4151 6.77368 13.2145 6.81011 12.9986C6.84655 12.7827 6.81932 12.5608 6.73174 12.3601C6.64417 12.1594 6.50004 11.9886 6.31697 11.8685C6.1339 11.7484 5.9198 11.6842 5.70084 11.6838C5.48189 11.6833 5.26754 11.7467 5.084 11.8661C4.90045 11.9854 4.75565 12.1557 4.66728 12.356C4.57891 12.5564 4.5508 12.7781 4.58638 12.9942C4.62197 13.2102 4.7197 13.4112 4.86765 13.5726C4.90592 13.6135 4.93445 13.6626 4.95109 13.7161C4.96773 13.7696 4.97206 13.8261 4.96375 13.8815C4.95671 13.9297 4.93868 13.9756 4.91104 14.0157C4.8834 14.0558 4.8469 14.0889 4.80437 14.1126C4.78498 14.1235 4.76495 14.1332 4.74437 14.1417C4.50916 14.2413 4.30898 14.4087 4.16938 14.6227C4.02978 14.8366 3.9571 15.0872 3.96062 15.3426V15.842H0.840045V10.8344H8.30717ZM10.5477 12.4614C10.0634 12.4606 9.59911 12.2676 9.2569 11.9249C8.91468 11.5821 8.72248 11.1176 8.72248 10.6332C8.72248 10.1488 8.91468 9.68429 9.2569 9.34153C9.59911 8.99877 10.0634 8.80582 10.5477 8.80504H12.5038C12.7441 8.80466 12.9822 8.85166 13.2043 8.94336C13.4265 9.03506 13.6283 9.16966 13.7984 9.33946C13.9685 9.50926 14.1034 9.71092 14.1955 9.93292C14.2875 10.1549 14.3349 10.3929 14.3349 10.6332C14.3349 10.8735 14.2875 11.1115 14.1955 11.3335C14.1034 11.5555 13.9685 11.7571 13.7984 11.9269C13.6283 12.0967 13.4265 12.2313 13.2043 12.323C12.9822 12.4147 12.7441 12.4617 12.5038 12.4614H10.5477ZM5.21312 13.2558C5.12676 13.1615 5.06972 13.0441 5.04898 12.9179C5.02824 12.7917 5.04468 12.6622 5.09631 12.5452C5.14794 12.4283 5.23251 12.3288 5.33971 12.2591C5.4469 12.1894 5.57207 12.1524 5.69994 12.1527C5.82781 12.1529 5.95284 12.1904 6.05976 12.2605C6.16668 12.3306 6.25087 12.4304 6.30204 12.5476C6.35322 12.6648 6.36916 12.7943 6.34793 12.9204C6.3267 13.0465 6.26922 13.1637 6.18249 13.2576C6.10281 13.3431 6.04211 13.4445 6.00438 13.5551C5.96665 13.6657 5.95275 13.783 5.96359 13.8994C5.97342 14.0094 6.00675 14.1161 6.06133 14.2121C6.11592 14.3082 6.19048 14.3914 6.27999 14.4562C6.34476 14.5033 6.41476 14.5428 6.48858 14.5739C6.63822 14.6407 6.76504 14.7499 6.85341 14.8879C6.94179 15.0259 6.98785 15.1867 6.98593 15.3506V15.842H4.42937V15.3426C4.42743 15.1804 4.47318 15.0213 4.56093 14.8848C4.64868 14.7484 4.77457 14.6408 4.92296 14.5753C4.96157 14.5594 4.99915 14.5411 5.03546 14.5204C5.13932 14.462 5.22852 14.3807 5.29633 14.2826C5.36414 14.1846 5.40878 14.0725 5.42687 13.9547C5.44639 13.8296 5.43729 13.7017 5.40027 13.5807C5.36325 13.4596 5.29926 13.3485 5.21312 13.2558ZM21.1903 18.9756H1.83192C1.56886 18.9753 1.31667 18.8707 1.1307 18.6846C0.944739 18.4986 0.840201 18.2463 0.84004 17.9833V16.3107H18.955C19.0172 16.3107 19.0768 16.286 19.1207 16.2421C19.1647 16.1981 19.1894 16.1385 19.1894 16.0764V15.3503C19.1928 15.0936 19.12 14.8416 18.9802 14.6263C18.8403 14.411 18.6397 14.2421 18.4037 14.1409C18.3639 14.1243 18.3261 14.1031 18.2913 14.0776C18.2555 14.0515 18.2257 14.018 18.2038 13.9795C18.182 13.9409 18.1687 13.8981 18.1647 13.854C18.1602 13.8035 18.1664 13.7527 18.183 13.7047C18.1995 13.6568 18.226 13.613 18.2608 13.5761C18.4095 13.4153 18.5081 13.2147 18.5447 12.9988C18.5812 12.7829 18.5541 12.561 18.4666 12.3603C18.3791 12.1595 18.235 11.9886 18.052 11.8684C17.8689 11.7482 17.6548 11.684 17.4358 11.6835C17.2169 11.683 17.0025 11.7463 16.8189 11.8656C16.6353 11.985 16.4904 12.1553 16.402 12.3556C16.3136 12.5559 16.2855 12.7777 16.3211 12.9938C16.3566 13.2098 16.4544 13.4109 16.6023 13.5723C16.6406 13.6133 16.6691 13.6624 16.6858 13.716C16.7024 13.7696 16.7068 13.8262 16.6984 13.8817C16.6913 13.9298 16.6733 13.9757 16.6456 14.0158C16.618 14.0558 16.5816 14.089 16.5391 14.1128C16.5197 14.1237 16.4996 14.1334 16.4791 14.1418C16.2438 14.2413 16.0436 14.4086 15.904 14.6225C15.7644 14.8363 15.6917 15.0869 15.6953 15.3423V15.842H11.753V12.8832H12.5038C13.0655 12.8825 13.6066 12.672 14.0211 12.293C14.4356 11.9139 14.6936 11.3937 14.7444 10.8344H22.1822V15.842H19.8975C19.8354 15.842 19.7758 15.8667 19.7318 15.9107C19.6879 15.9546 19.6632 16.0142 19.6632 16.0764C19.6632 16.1386 19.6879 16.1982 19.7318 16.2421C19.7758 16.2861 19.8354 16.3108 19.8975 16.3108H22.1822V17.9833C22.1821 18.2463 22.0775 18.4986 21.8916 18.6846C21.7056 18.8707 21.4534 18.9753 21.1903 18.9756ZM16.9473 13.2554C16.861 13.1611 16.8039 13.0437 16.7832 12.9176C16.7625 12.7914 16.7789 12.6619 16.8305 12.5449C16.8822 12.4279 16.9667 12.3285 17.0739 12.2588C17.1811 12.1891 17.3063 12.1521 17.4342 12.1523C17.562 12.1526 17.6871 12.1901 17.794 12.2602C17.9009 12.3303 17.9851 12.4301 18.0363 12.5472C18.0874 12.6644 18.1034 12.794 18.0822 12.9201C18.0609 13.0462 18.0034 13.1633 17.9167 13.2573C17.8373 13.3429 17.7767 13.4443 17.7391 13.5549C17.7015 13.6655 17.6875 13.7827 17.6983 13.899C17.7081 14.0091 17.7414 14.1158 17.7959 14.2119C17.8505 14.3079 17.9251 14.3912 18.0147 14.4559C18.0793 14.5032 18.1494 14.5427 18.2233 14.5736C18.3729 14.6404 18.4997 14.7495 18.5881 14.8875C18.6765 15.0255 18.7225 15.1864 18.7206 15.3503V15.842H16.1641V15.3423C16.1622 15.1801 16.208 15.021 16.2957 14.8846C16.3834 14.7482 16.5093 14.6405 16.6576 14.575C16.6963 14.5592 16.7338 14.541 16.7702 14.5206C16.8739 14.462 16.9629 14.3806 17.0306 14.2826C17.0984 14.1846 17.143 14.0725 17.1611 13.9548C17.1808 13.8297 17.1718 13.7016 17.1348 13.5805C17.0978 13.4593 17.0337 13.3482 16.9473 13.2554ZM16.9473 7.73874C16.861 7.64444 16.8039 7.52703 16.7832 7.40086C16.7625 7.27468 16.7789 7.1452 16.8305 7.02822C16.8822 6.91123 16.9667 6.81181 17.0739 6.7421C17.1811 6.67239 17.3063 6.63539 17.4342 6.63564C17.562 6.63589 17.6871 6.67336 17.794 6.74349C17.9009 6.81362 17.9851 6.91337 18.0363 7.03055C18.0874 7.14773 18.1034 7.27728 18.0822 7.40337C18.0609 7.52947 18.0034 7.64665 17.9167 7.74061C17.8372 7.82629 17.7767 7.92777 17.739 8.03842C17.7014 8.14907 17.6875 8.26642 17.6983 8.3828C17.7081 8.49279 17.7415 8.59938 17.796 8.69537C17.8506 8.79137 17.9252 8.87452 18.0147 8.93921C18.0792 8.98666 18.1493 9.02617 18.2233 9.05686C18.3729 9.12374 18.4997 9.23289 18.588 9.3709C18.6764 9.5089 18.7225 9.66972 18.7206 9.83358V10.4125H16.1641V9.82561C16.1622 9.6635 16.208 9.5044 16.2957 9.36807C16.3835 9.23174 16.5093 9.12418 16.6576 9.05874C16.6962 9.04264 16.7337 9.02433 16.7702 9.00389C16.8739 8.9453 16.9629 8.86394 17.0306 8.76594C17.0984 8.66794 17.143 8.55585 17.1611 8.43811C17.1808 8.31296 17.1718 8.18496 17.1348 8.06379C17.0978 7.94263 17.0337 7.83147 16.9473 7.73874ZM22.1822 10.4125H19.1894V9.83358C19.1928 9.57687 19.12 9.32492 18.9802 9.10962C18.8403 8.89433 18.6397 8.72539 18.4037 8.62421C18.3639 8.60765 18.3261 8.58641 18.2913 8.56093C18.2555 8.5348 18.2257 8.50134 18.2038 8.46279C18.182 8.42423 18.1687 8.38146 18.1647 8.33733C18.1602 8.28684 18.1664 8.23596 18.183 8.18805C18.1995 8.14014 18.226 8.09628 18.2608 8.05936C18.4095 7.8986 18.5081 7.69802 18.5447 7.48211C18.5812 7.2662 18.5541 7.04432 18.4666 6.84358C18.3791 6.64284 18.235 6.47193 18.052 6.35174C17.8689 6.23155 17.6548 6.16728 17.4358 6.16678C17.2169 6.16629 17.0025 6.22959 16.8189 6.34895C16.6353 6.46831 16.4904 6.63856 16.402 6.83891C16.3136 7.03925 16.2855 7.26101 16.3211 7.47708C16.3566 7.69315 16.4544 7.89418 16.6023 8.05561C16.6406 8.09662 16.6691 8.14574 16.6858 8.19931C16.7024 8.25288 16.7068 8.30951 16.6984 8.36499C16.6914 8.41316 16.6734 8.45907 16.6457 8.49914C16.6181 8.53922 16.5816 8.57239 16.5391 8.59608C16.5197 8.60698 16.4996 8.61669 16.4791 8.62514C16.2438 8.7246 16.0436 8.89194 15.904 9.10579C15.7644 9.31963 15.6917 9.57025 15.6953 9.82561V10.4125H14.7429C14.6874 9.85693 14.4277 9.34174 14.014 8.9668C13.6003 8.59186 13.0621 8.38388 12.5038 8.38317H10.5477C9.98939 8.38387 9.45122 8.59185 9.03753 8.96679C8.62384 9.34173 8.3641 9.85692 8.30867 10.4125H0.840045V7.90053C0.8973 7.91392 0.956193 7.91895 1.01489 7.91545C2.93958 7.78983 4.01254 8.25998 4.57317 8.67623C4.76767 8.82198 5.00418 8.90076 5.24723 8.90076C5.49029 8.90076 5.72679 8.82198 5.92129 8.67623C6.48192 8.25998 7.55395 7.78983 9.47958 7.91545C9.56213 7.92073 9.64489 7.90903 9.72274 7.88108C9.8006 7.85313 9.87191 7.80953 9.93226 7.75295C9.99261 7.69638 10.0407 7.62804 10.0736 7.55215C10.1066 7.47626 10.1236 7.39442 10.1236 7.3117V5.41701H19.0906L18.6655 5.94583C18.6378 5.98028 18.6205 6.02185 18.6154 6.06575C18.6103 6.10966 18.6178 6.1541 18.6369 6.19395C18.656 6.2338 18.6859 6.26745 18.7233 6.29099C18.7607 6.31454 18.804 6.32703 18.8482 6.32703H19.545V6.59594C19.5452 6.77246 19.6154 6.94168 19.7402 7.0665C19.8651 7.19131 20.0343 7.26152 20.2108 7.26171H22.1822L22.1822 10.4125ZM23.1602 6.59595C23.1601 6.64818 23.1394 6.69826 23.1024 6.7352C23.0655 6.77213 23.0154 6.79291 22.9632 6.79297H20.2108C20.1585 6.79291 20.1085 6.77213 20.0715 6.7352C20.0346 6.69826 20.0138 6.64818 20.0138 6.59595V6.09266C20.0138 6.0305 19.9891 5.97088 19.9451 5.92693C19.9012 5.88297 19.8415 5.85828 19.7794 5.85828H19.3373L19.8707 5.19475C19.9041 5.15313 19.9224 5.10133 19.9223 5.04792V4.62248C19.9224 4.57024 19.9432 4.52017 19.9801 4.48323C20.0171 4.4463 20.0671 4.42552 20.1194 4.42546H22.9632C23.0154 4.42552 23.0655 4.4463 23.1024 4.48323C23.1394 4.52017 23.1601 4.57024 23.1602 4.62248V6.59595Z"
                                      fill="black"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_2345_13759">
                                      <rect
                                        width="24"
                                        height="24"
                                        fill="white"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                                {t("groupWebinars")}
                              </div>
                            )}
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  )}
                  {!_.isEmpty(coachData?.certifications) ? (
                    <div className="infopx">
                      <h2 className="pge-tiel">
                        {t("certifications&Credentials")}
                      </h2>
                      <div className="certificatbx d-flex gap-5 flex-wrap">
                        {coachData?.certifications?.map((certification) => (
                          <div className="certifcatimg" key={certification.id}>
                            {/* Use the provided URL for the image */}
                            {certification.type === "pdf" ? (
                              <img
                                src="/images/certificate.png"
                                alt="PDF Placeholder"
                              />
                            ) : (
                              <img
                                src={certification.url}
                                alt={certification.name}
                              />
                            )}
                            {/* Display the certification name */}
                            {/* <p>
                                                        <strong>{certification.name}</strong>
                                                    </p> */}
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {coachData?.userId ? (
                    <div className="infopx" id="container-slot">
                      <SlotBookingModal
                        currencySymbol={
                          coachData?.purchased_info?.currency_symbol
                        }
                        currencyCode={coachData?.purchased_info?.currency_code}
                        sellingPrice={coachData?.purchased_info?.selling_price}
                        coachId={coachData?.userId}
                        productId={coachData?.productId}
                        serviceSlots={coachData?.service_slots}
                        masterPriceId={coachData?.master_price_id}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  <hr />
                  {ratingLoader ? (
                    <div className="container">
                      <div className="row">
                        {[1, 2, 3]?.map((item) => (
                          <div className="sliderse col-4">
                            <div className="feedbackov">
                              <div className="d-flex justify-content-between gap-3">
                                <div className="imbbox">
                                  <ShimmerScreen
                                    case="circle"
                                    width="1rem"
                                    height="1rem"
                                  />
                                </div>
                                <div className="ratingbox">
                                  <ShimmerScreen
                                    width={"5rem"}
                                    height={"1.2rem"}
                                    case={"rect"}
                                  />
                                </div>
                              </div>
                              <div className="namestuder">
                                <ShimmerScreen
                                  width={"5rem"}
                                  height={"1.2rem"}
                                  case={"rect"}
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : !_.isEmpty(ratingFeedbackList) ? (
                    <>
                      <div className="d-flex justify-content-between gap-3">
                        <h3>{t("Learner's Feedback")}</h3>
                      </div>
                      <div className="sliderse">
                        <Slider {...settings}>
                          {ratingFeedbackList?.map((item, index) => (
                            <div>
                              <div className="feedbackov">
                                <div className="d-flex justify-content-between gap-3">
                                  <div className="imbbox">
                                    {/* <img
                                      src={
                                        item?.image
                                          ? item?.image
                                          : "/images/avatar.svg"
                                      }
                                      alt="pic"
                                    /> */}
                                    <ReactRoundedImage
                                      id="profileImg"
                                      image={
                                        item?.image
                                          ? item?.image
                                          : "/images/avatar.svg"
                                      }
                                      roundedSize="0"
                                      imageWidth="50"
                                      imageHeight="50"
                                    />
                                  </div>
                                  <div className="ratingbox">
                                    <Rating
                                      name="half-rating"
                                      value={item?.rating}
                                      precision={0.5}
                                      readOnly
                                    />
                                  </div>
                                </div>
                                <div className="namestuder">
                                  {item?.from_name}
                                </div>
                                <p>{item?.remark}</p>
                              </div>
                            </div>
                          ))}
                        </Slider>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
      <CoachRating
        show={show}
        handleClose={handleClose}
        isLoading={loader}
        setIsLoading={setLoader}
        coachId={coachData?.userId}
        coachName={coachData?.display_name}
        coachImage={coachData?.thumbnail}
        coachDesignation={coachData?.designation}
        coachExperience={coachData?.experience}
        entityType={"coach"}
      />
      {sessionModal && (
        <div id="slot-container">
          <SlotBookingModal
            sessionModal={sessionModal}
            setSessionModal={setSessionModal}
            selectedCoachId={selectedCoachId}
            setIsLoading={setLoader}
            productTitle={productTitle}
            productId={productId}
            displayName={displayName}
          />
        </div>
      )}
    </Page>
  );
}

export default CoacheDetail;
